const forms = [
  {
    name: "Date",
    className: "bg-white p-4 rounded-md p-8 w-[100%] mx-auto",
    options: [
      {
        name: "Date",
        type: "date",
        form: {
          type: "text",
          name: "date",
          placeholder: "Request date",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Branch",
        type: "select",
        form: {
          name: "supplier",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Branch",
          api: "get-all-branches",
          options: null,
          value: null,
          required: true,
        },
      },
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            {
              value: 1,
              label: "Not-accepted",
            },
            {
              value: 0,
              label: "Accepted",
            },
          ],
          required: false,
        },
      },
    ],
  },
];

export default forms;
